export const PAGE_CONFIG = {
  title: 'Return',
  titleCN: '回流',
  subTitle: '',
  subTitleCN: '',
  path: '/engagement/rateReturn',
  defaultTab: 'newUsers',
  tabList: [
    {
      id: 'newUsers',
      tabName: 'New Users',
      tabNameCN: '新进用户',
      isHaveNotification: true,
      notificationPath: '/engagement/rateReturn/returnNewUsers',
      path: '/engagement/rateReturn/returnNewUsers',
      logConfig: {
        pageId: '205201',
        pageName: 'returnV2NewUsers',
        extInfo: 'returnV2NewUsers',
        pagePath: '/engagement/rateReturn/returnNewUsers',
      },
      filters: [
        {
          name: 'ReturnV2Filter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/rateReturn/returnNewUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/rateReturn/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Return -New Users',
                  titleCN: '新进用户次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'New Users Return',
                  cnChartTooltipsName: '新进用户回流',
                }
              },
              data: {
                tag: 'new',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/rateReturn/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/rateReturn/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'New',
                      cnName: '注册',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },

                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Return -New Users',
                  titleCN: '新进用户回流',
                }
              },
              data: {
                tag: 'new',
                retentionColumsNum: '1'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'activeUsers',
      tabName: 'Active Users',
      tabNameCN: '活跃用户',
      isHaveNotification: true,
      notificationPath: '/engagement/rateReturn/returnActiveUsers',
      path: '/engagement/rateReturn/returnActiveUsers',
      logConfig: {
        pageId: '205202',
        pageName: 'returnV2ActiveUsers',
        extInfo: 'returnV2ActiveUsers',
        pagePath: '/engagement/rateReturn/returnActiveUsers',
      },
      filters: [
        {
          name: 'ReturnV2Filter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/rateReturn/returnActiveUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/rateReturn/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Return -Active Users',
                  titleCN: '活跃用户次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'Active Users Return',
                  cnChartTooltipsName: '活跃用户回流',
                }
              },
              data: {
                tag: 'active',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/rateReturn/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/rateReturn/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'Active Users',
                      cnName: '活跃用户',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Return -Active Users',
                  titleCN: '活跃用户回流',
                }
              },
              data: {
                tag: 'active',
                retentionColumsNum: '1'
              }
            },
          ]
        },
      ],
    },
  ],
}